import React, { forwardRef } from "react";
import ButtonAction from "@streeteasy/design-system/button-action";
import actionElements from "@streeteasy/design-system/constants/actionElements";
import componentSizes from "@streeteasy/design-system/constants/componentSizes";
import { node, oneOf, string } from "prop-types";

import buttonThemes from "./buttonThemes";

/**
 * @deprecated use the ButtonAction component instead
 */
const ButtonLink = forwardRef(
  ({ href, size, theme, ...passThroughProps }, ref) => (
    <ButtonAction
      ref={ref}
      element={actionElements.a}
      href={href}
      size={size}
      theme={theme}
      {...passThroughProps}
    />
  )
);

ButtonLink.displayName = "ButtonLink";

ButtonLink.propTypes = {
  children: node.isRequired,
  /**
   * Determines the size of the ButtonLink.
   *
   * Values for the size prop are imported from the componentSizes module.
   *
   * ```
   * import ButtonLink from "./ButtonLink";
   * ```
   * ```
   * import componentSizes from "./path/to/componentSizes";
   *```
   *```
   * export const MyButtonLink = () => (
   *   <ButtonLink href="/valuation" size={componentSizes.SM}>
   *     Get a free valuation
   *   </ButtonLink>
   * );
   * ```
   * */
  href: string.isRequired,
  size: oneOf([componentSizes.SM, componentSizes.MD, componentSizes.LG]),
  /**
   * Determines background and text color of the ButtonLink.
   *
   * Values for the theme prop are imported from the ButtonLinkThemes module.
   *
   * ```
   * import ButtonLink from "./ButtonLink";
   * ```
   * ```
   * import themes from "./buttonThemes";
   *```
   *```
   * export const MyButtonLink = () => (
   *   <ButtonLink href="/valuation" theme={themes.SECONDARY}>
   *     Get a free valuation
   *   </ButtonLink>
   * );
   * ```
   * */
  theme: oneOf(Object.values(buttonThemes))
};

ButtonLink.defaultProps = {
  size: componentSizes.MD,
  theme: buttonThemes.PRIMARY
};

export default ButtonLink;
